import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavCommon from '../../components/navCommon';
import CardContainerCommon from '../../components/cardCommon';
import MyLoader from '../../components/placeholderCommon';
import { Container, Margin } from './styles';
import icons from '../../constants/icons';
import ItemCard from '../../components/itemCardCommon';
import ItemListDrop from '../../components/itemListDropCommon';
import axios from '../../services/criterion';
import warn from '../../constants/toast';
import { Criterios } from '../../interfaces';

const Discrations = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [openDrop, setOpenDrop] = useState<boolean>(false);
  const [criterions, setCriterions] = useState<Array<Criterios>>([]);

  useEffect(() => {
    requestCriterions();
  }, []);

  const requestCriterions = async () => {
    try {
      setLoading(true);
      const response = await axios.GetAllCriteria();
      setCriterions(response.data.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const Body = () => (
    <>
      <Container>
        {loading ? (
          <Margin>
            <MyLoader />
          </Margin>
        ) : null}
        {!loading && (
          criterions.map((item) => (
            <ItemCard
              widthImg="50%"
              heightImg="auto"
              key={item.idCriterio}
              img={`data:image/png;base64,${item.iconeBase64}`}
              icon={icons.editIcon}
              id={item.idCriterio}
              onClick={() => {
                if (item.tipoCriterio === 1) {
                  history.push('/cadastrar-criterio-simples', {
                    criterion: item,
                  });
                } if (item.tipoCriterio === 2) {
                  history.push('/cadastrar-criterio-variavel', {
                    criterion: item,
                  });
                }
              }}
              title={item.nome}
              subTitle1={item.descricao}
            />
          ))
        )}
      </Container>
    </>
  );

  const ListToDrop = (): any => (
    <div>
      <ItemListDrop onPress={() => history.push('/cadastrar-criterio-simples')} name="Simples" />
      <ItemListDrop onPress={() => history.push('/cadastrar-criterio-variavel')} name="Variável" />
    </div>
  );

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: '/polipositions', name: 'Pole positions' },
          { path: '/criterios-poleposition', name: 'Critérios' },
        ]}
        showDrop={false}
        hasOnChange
        onBack={() => { history.goBack(); }}
        setOpen={setOpenDrop}
        open={openDrop}
        options={ListToDrop()}
        onChange={() => {
          setOpenDrop(!openDrop);
        }}
      />
      <CardContainerCommon title="Critérios" childrens={Body()} hasFilter={false} />
    </>
  );
};
export default Discrations;
